import React from 'react'
import {Media} from "reactstrap";
import dateHelpers from "../../helpers/DateHelper";
import paymentTypeHelpers from "../../helpers/PaymentTypeHelper";
import categoryHelpers from "../../helpers/CategotyHelper";

const propTypes = {};

class IncomeReportRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            income: props.income,
            currency: props.currency
        };

    }

    render() {
        return (
            <tr onClick={e => this.props.onIncomeSelected(e, this.state.income)} style={{cursor: "pointer"}}>
                <th scope="row">
                    <Media className="align-items-center">
                        <Media>
                            <span className="mb-0 text-sm">
                                {this.state.income && this.state.income.title ? this.state.income.title.substring(0,30) : "..."}
                            </span>
                        </Media>
                    </Media>
                </th>
                <td>
                    <img
                        style={{marginRight: '1rem'}}
                        width={18}
                        height={18}
                        alt="pm"
                        src={this.categoryIcon()}
                    />
                    <span className="mb-0 text-sm">
                        {this.translateCategory()}
                    </span>
                </td>
                <td>
                    <span className="mb-0 text-sm">
                        {dateHelpers.formatDate(new Date(this.state.income.date))}
                    </span>
                </td>
                <td>
                    <span className="mb-0 text-sm">
                        {this.price()}
                    </span>
                </td>
                <td className="text-right align-content-end">
                    <span className="mb-0 text-sm">
                        {this.getPaymentMethod()}
                    </span>
                </td>
            </tr>
        )
    }

    price() {
        return this.state.currency + (parseFloat(this.state.income && this.state.income.price ? this.state.income.price : "0") * this.state.income.qty).toFixed(2)
    }

    getPaymentMethod() {
        if (this.state.income != null && this.state.income.pt) {
            let pm = paymentTypeHelpers.paymentTypes().find(p => p.value === this.state.income.pt);

            if (pm === undefined) {
                pm = paymentTypeHelpers.paymentTypes()[paymentTypeHelpers.paymentTypes().length - 1].label
            }

            return pm.label
        } else {
            return paymentTypeHelpers.paymentTypes()[paymentTypeHelpers.paymentTypes().length - 1].label
        }
    }

    translateCategory() {
        if (this.state.income != null && this.state.income.category) {
            let cat = categoryHelpers.categories().find(p => p.value === this.state.income.category);

            if (cat === undefined) {
                cat = categoryHelpers[categoryHelpers.categories().length - 1].label
            }

            return cat.label
        } else {
            return categoryHelpers.categories()[categoryHelpers.categories().length - 1].label
        }
    }

    categoryIcon() {
        if (this.state.income != null && this.state.income.category) {
            let cat = categoryHelpers.categories().find(p => p.value === this.state.income.category);

            if (cat === undefined) {
                cat = categoryHelpers[categoryHelpers.categories().length - 1].icon
            }

            return cat.icon
        } else {
            return categoryHelpers.categories()[categoryHelpers.categories().length - 1].icon
        }
    }
}

IncomeReportRow.propTypes = propTypes;

export default IncomeReportRow;